import { NodeEditorComponentTypes } from '../interfaces/flow-ui.interface';
import { NodeType } from '../interfaces/node.interface';

export const nodeEditorComponentConfig: NodeEditorComponentTypes = {
  [NodeType.Condition]: async () => {
    const comp = await import('../node-editor-components/node-editor-if/node-editor-if.component');

    return comp.NodeEditorIfComponent;
  },
  [NodeType.HttpAction]: async () => {
    const comp = await import('../node-editor-components/node-editor-action/node-editor-action.component');

    return comp.NodeEditorActionComponent;
  },
  [NodeType.Switch]: async () => {
    const comp = await import('../node-editor-components/node-editor-switch/node-editor-switch.component');

    return comp.NodeEditorSwitchComponent;
  },
  [NodeType.Loop]: async () => {
    const comp = await import('../node-editor-components/node-editor-loop/node-editor-loop.component');

    return comp.NodeEditorLoopComponent;
  },
  [NodeType.DtoTransformation]: async () => {
    const comp =
      await import('../node-editor-components/node-editor-dto-transform/node-editor-dto-transform.component');

    return comp.NodeEditorDtoTransformComponent;
  },
  [NodeType.Scheduler]: async () => {
    const comp = await import('../node-editor-components/node-editor-scheduler/node-editor-scheduler.component');

    return comp.NodeEditorSchedulerComponent;
  },
  [NodeType.Wait]: async () => {
    const comp = await import('../node-editor-components/node-editor-wait/node-editor-wait.component');

    return comp.NodeEditorWaitComponent;
  },
  [NodeType.Webhook]: async () => {
    const comp = await import('../node-editor-components/node-editor-webhook/node-editor-webhook.component');

    return comp.NodeEditorWebhookComponent;
  },
  [NodeType.UrlEncoding]: async () => {
    const comp = await import('../node-editor-components/node-editor-url-encoding/node-editor-url-encoding.component');

    return comp.NodeEditorUrlEncodingComponent;
  },
  [NodeType.Uuid]: async () => {
    const comp = await import('../node-editor-components/node-editor-uuid/node-editor-uuid.component');

    return comp.NodeEditorUuidComponent;
  },
  [NodeType.DtoSet]: async () => {
    const comp = await import('../node-editor-components/node-editor-dto-set/node-editor-dto-set.component');

    return comp.NodeEditorDtoSetComponent;
  },
  [NodeType.Notify]: async () => {
    const { NodeEditorNotifyComponent } =
      await import('../node-editor-components/node-editor-notify/node-editor-notify.component');

    return NodeEditorNotifyComponent;
  },
  [NodeType.HttpResponse]: async () => {
    const { NodeEditorHttpResponseComponent } =
      await import('../node-editor-components/node-editor-http-response/node-editor-http-response.component');

    return NodeEditorHttpResponseComponent;
  },
  [NodeType.Api]: async () => {
    const { NodeEditorApiComponent } =
      await import('../node-editor-components/node-editor-api/node-editor-api.component');

    return NodeEditorApiComponent;
  },
  [NodeType.UserCache]: async () => {
    const { NodeEditorUserCacheComponent } =
      await import('../node-editor-components/node-editor-user-cache/node-editor-user-cache.component');

    return NodeEditorUserCacheComponent;
  },
  [NodeType.Annotation]: async () => {
    const { NodeEditorAnnotationComponent } =
      await import('../node-editor-components/node-editor-annotation/node-editor-annotation.component');

    return NodeEditorAnnotationComponent;
  },
  [NodeType.HttpRequest]: async () => {
    const { NodeEditorHttpRequestComponent } =
      await import('../node-editor-components/node-editor-http-request/node-editor-http-request.component');

    return NodeEditorHttpRequestComponent;
  },
  [NodeType.EneqtoData]: async () => {
    const { NodeEditorEneqtoDataComponent } =
      await import('../node-editor-components/node-editor-eneqto-data/node-editor-eneqto-data.component');

    return NodeEditorEneqtoDataComponent;
  },
};
